import { createSagas } from "redux-box";
import GradeApi from "@s/api/grade";
import PassagesApi from "@s/api/passages";
import { call, put } from "redux-saga/effects";
import swal from "sweetalert2";
import { PASSAGES_HIDDEN_GRADES } from "../../utils/constant";

const errorHandler = (err) => {
  //console.log(err);
  swal("Oops! ", err.error_message, "error");
};

export default createSagas({
  REQUEST_PASSAGE_BY_ACTIVE_GRADE: function*() {
    try {
      const res = yield call(GradeApi.getAllGrades);
      if (res && res.length > 0) {
        let grades = res.filter(
          (grade) => !PASSAGES_HIDDEN_GRADES.includes(grade.name)
        );

        yield put({
          type: "REQUEST_PASSAGE_LIST_BY_GRADE_ID",
          grade: grades[0],
        });
        yield put({
          type: "SET_ACTIVE_PASSAGE_GRADE",
          grade: grades[0],
        });
      }
    } catch (err) {}
  },

  REQUEST_PASSAGE_LIST_BY_GRADE_ID: function*({ grade }) {
    try {
      yield put({
        type: "SET_FETCH_PASSAGE_LIST",
        value: true,
      });
      yield put({
        type: "SET_ACTIVE_PASSAGE_GRADE",
        grade: grade,
      });

      const res = yield call(PassagesApi.getPassagesList, grade.name, 0);
      yield put({
        type: "SET_PASSAGE_RESULT",
        result: res,
      });
      if (res && res.result && res.result.length > 0)
        yield put({
          type: "SET_PASSAGE_LIST",
          passageList: res.result,
        });
      yield put({
        type: "SET_FETCH_PASSAGE_LIST",
        value: false,
      });
    } catch (err) {
      errorHandler(err);
    }
  },
  REQUEST_PASSAGE_BY_ID: function*({ passageId }) {
    try {
      yield put({
        type: "FETCH_PASSAGE",
        value: true,
      });

      const res = yield call(PassagesApi.getPassageById, passageId);
      yield put({
        type: "SET_ACTIVE_PASSAGE",
        activePassage: res,
      });

      yield put({
        type: "SET_ACTIVE_PASSAGE_GRADE",
        grade: res.grade,
      });
      yield put({
        type: "FETCH_PASSAGE",
        value: false,
      });
      // if (res.section_data && res.section_data.length === 0) {
      //   defaultSections.forEach(function(section) {
      //     require("store").default.dispatch({
      //       type: "ADD_NEW_READING_SECTION",
      //       section,
      //     });
      //   });
      // }
    } catch (err) {
      errorHandler(err);
    }
  },

  REQUEST_CONCAT_PASSAGES: function*({ offset }) {
    try {
      const gState = require("store").default.getState();
      console.log("inside", gState);
      const grade = gState.passages.active_passage_grade;

      console.log(grade);

      const res = yield call(PassagesApi.getPassagesList, grade.name, offset);
      console.log(res);
      yield put({
        type: "SET_PASSAGE_RESULT",
        result: res,
      });
      if (res && res.result && res.result.length > 0)
        yield put({
          type: "SET_CONCAT_PASSAGE_LIST",
          passageList: res.result,
        });
    } catch (err) {
      errorHandler(err);
    }
  },

  REQUEST_PASSAGE: function*() {
    try {
      yield put({
        type: "SET_FETCH_PASSAGE_LIST",
        value: true,
      });

      const gState = require("store").default.getState();
      const grade = gState.passage2.active_passage_grade;

      const res = yield call(PassagesApi.getPassagesList, grade.name, 0);
      yield put({
        type: "SET_PASSAGE_RESULT",
        result: res,
      });
      if (res && res.result && res.result.length > 0)
        yield put({
          type: "SET_PASSAGE_LIST",
          passageList: res.result,
        });
    } catch (err) {
      errorHandler(err);
    } finally {
      yield put({
        type: "SET_FETCH_PASSAGE_LIST",
        value: false,
      });
    }
  },

  REQUEST_UPDATE_PASSAGE: function*({ passage }) {
    const gState = require("store").default.getState();
    console.log("inside", gState);
    const grade = gState.passages.active_passage_grade;
    try {
      const res = yield call(PassagesApi.updatePassage, passage.id, passage);
      if (res) {
        yield put({
          type: "REQUEST_PASSAGE_LIST_BY_GRADE_ID",
          grade: grade,
        });
        // yield put({
        //   type: "REQUEST_PASSAGE",
        // });
      }
    } catch (err) {
      errorHandler(err);
    }
  },
});
